import { ReactNode, useEffect, useState, useRef } from 'react';
import { Button } from '../../elements/Button';
import { CaretDownOutLined, CaretUpOutLined } from '../../icons/truWeb-icons';
import './style.scss';

type Props = {
  value?: string | number;
  children: ReactNode;
  placeholder?: string;
  disabled?: boolean;
  classes?: string;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
};
export const Select = ({
  value = '',
  placeholder,
  disabled = false,
  children,
  onChange,
  onBlur,
  classes,
}: Props) => {
  const [isOpened, setIsOpened] = useState(false);
  const handleToggleOpened = () => setIsOpened(!isOpened);
  const selectRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpened) return;
    const handleClickOutside = (e: MouseEvent) => {
      const isOutsideClick = !selectRef.current?.contains(e.target as Element);
      if (!isOutsideClick) return;
      setIsOpened(false);
    };
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isOpened]);
  return (
    <div className={`tru-single-select-arrow-wrapper ${classes} ${disabled ? 'disabled-select' : ''}`} ref={selectRef}>
      <select
        value={value}
        disabled={disabled}
        className="tru-select"
        onBlur={(event) => onBlur?.(event.currentTarget.value)}
        onChange={(event) => onChange?.(event.currentTarget.value)}
        onClick={handleToggleOpened}
      >
        <option disabled hidden value="">
          {placeholder}
        </option>
        {children}
      </select>
      <div className="caret-up-and-down">
        <Button type="link">
          {isOpened ? (
            <CaretUpOutLined />
          ) : (
            <CaretDownOutLined />
          )}
        </Button>
      </div>
    </div>
  );
};
